<og-auth-shell active=""
  ><section class="og-auth-form">
    <h2>Forgot <span>password?</span></h2>
    <p class="auth-description">
      Enter your email and we’ll send you a link to reset your password.
    </p>
    <fuse-alert
      class="mt-8 -mb-4"
      *ngIf="showAlert"
      [appearance]="'outline'"
      [showIcon]="false"
      [type]="alert.type"
      [@shake]="alert.type === 'error'"
    >
      {{ alert.message }}
    </fuse-alert>

    <form
      (ngSubmit)="sendResetLink()"
      class="mt-8"
      [formGroup]="forgotPasswordForm"
      #forgotPasswordNgForm="ngForm"
    >
      <mat-form-field subscriptSizing="dynamic" class="auth-full">
        <input
          aria-label="Email address"
          placeholder="Email address"
          id="email"
          type="email"
          autocomplete="email"
          matInput
          [formControlName]="'email'"
        />
        <mat-error *ngIf="forgotPasswordForm.get('email').hasError('required')">
          Email address is required
        </mat-error>
        <mat-error *ngIf="forgotPasswordForm.get('email').hasError('email')">
          Please enter a valid email address
        </mat-error>
      </mat-form-field>

      <button
        class="auth-submit"
        mat-flat-button
        [color]="'primary'"
        [disabled]="(isLoading$ | async) || forgotPasswordForm.invalid"
        type="submit"
      >
        <span *ngIf="!(isLoading$ | async)"> Send reset link </span>
        <mat-progress-spinner
          *ngIf="isLoading$ | async"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>

      <div class="auth-footer">
        <span>Return to</span>
        <a class="ml-1 text-primary-500 hover:underline" [routerLink]="['/authentication/sign-in']"
          >sign in
        </a>
      </div>
    </form>
  </section></og-auth-shell
>
